import { render, staticRenderFns } from "./SnapBar.vue?vue&type=template&id=77fcff3a&scoped=true&"
import script from "./SnapBar.vue?vue&type=script&lang=js&"
export * from "./SnapBar.vue?vue&type=script&lang=js&"
import style0 from "./SnapBar.vue?vue&type=style&index=0&id=77fcff3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fcff3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fcff3a')) {
      api.createRecord('77fcff3a', component.options)
    } else {
      api.reload('77fcff3a', component.options)
    }
    module.hot.accept("./SnapBar.vue?vue&type=template&id=77fcff3a&scoped=true&", function () {
      api.rerender('77fcff3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/Snapbar/SnapBar.vue"
export default component.exports